"use client";

import { ShieldCheck, Star, Truck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const trustPillars = [{
  id: 1,
  iconType: "stars",
  mainText: "",
  subText: "PRECISION DATA MATCHING"
}, {
  id: 2,
  iconType: "text",
  mainText: "VIN",
  subText: "VEHICLE IDENTIFICATION SYNC"
}, {
  id: 3,
  iconType: "shield",
  mainText: "",
  subText: "SECURE OFFICIAL RECORDS"
}, {
  id: 4,
  iconType: "truck",
  mainText: "",
  subText: "INSTANT SEARCH RESULTS"
}];
export default function TheVendiTrustPillars() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="101140" id="why-accuracy-matters" className="bg-[#212B36] py-20 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-center text-3xl md:text-4xl font-bold text-[#66CCFF] tracking-tight mb-12 md:mb-16 uppercase font-sans">
          Why Data Accuracy Matters
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 md:gap-8 text-center">
          {trustPillars.map((pillar, i) => <div key={pillar.id} data-index={i} className="flex flex-col items-center justify-start gap-5">
              <div className="h-16 flex items-center justify-center text-[#66CCFF]">
                {pillar.iconType === "stars" && <div className="flex gap-1">
                    {[...Array(5)].map((_, starIdx) => <Star key={starIdx} data-index={starIdx} className="w-8 h-8 md:w-10 md:h-10 fill-current" />)}
                  </div>}
                {pillar.iconType === "text" && <span className="text-4xl md:text-5xl font-bold tracking-tighter text-[#66CCFF]">
                    {pillar.mainText}
                  </span>}
                {pillar.iconType === "shield" && <ShieldCheck className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1.5} />}
                {pillar.iconType === "truck" && <Truck className="w-12 h-12 md:w-14 md:h-14" strokeWidth={1.5} />}
              </div>
              <h3 className="text-base font-semibold uppercase text-white tracking-widest max-w-[200px] mx-auto leading-snug font-sans">
                {pillar.subText}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}